<template lang="html">
  <div class="showLargeScreenOnly">
    <!-- Lien d'évitement pour l'accessibilité -->
    <a href="#main-content" class="sr-only sr-only-focusable skip-link">Aller au contenu principal</a>
    
    <!-- Header supérieur avec logo -->
    <b-navbar type="faded" class="header-top d-flex justify-content-between align-items-center p-2" role="banner">
      <b-navbar-brand href="#" class="d-flex align-items-center py-0">
        <img :src="imgVarsLong" @click="loadAccueil" alt="DealPrudence" class="heritage-web-header largescreen">
      </b-navbar-brand>
      
      <!-- Section profil et langue déplacée ici -->
      <div class="d-flex align-items-center">
        <b-navbar-nav fill class="mx-0">
          <b-nav-item-dropdown v-if="this.$engine.firstOn().user && this.$engine.firstOn().user.userAccountId !== 1" 
            ref="log" 
            class="logOut" 
            toggle-class="d-flex align-items-center" 
            right 
            variant="link"
            :aria-label="$t('common.user_menu')"
            @mouseover.native="autoDropdown(true, 'log')" 
            @mouseleave.native="autoDropdown(false, 'log')">
            <template v-slot:button-content>
              <img class="navbarProfileImage mr-2" :src="imgProfil" :alt="$t('common.profile_picture')"/>
              <div class="d-flex flex-column align-items-start">
                <span class="d-inline mr-2 mb-0 text-menu profile-menu font-weight-bold"> {{ companyName }} </span>
                <span class="d-inline mr-2 mb-0 text-menu profile-menu"> {{ userName }} </span>
              </div>
            </template>
            <b-dropdown-item @click="goToLink('/profile/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.my_prfl') }}</b-dropdown-item>
            <b-dropdown-item v-if="hasMultipleAccounts()" @click="activateModalProfile" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('leftPanelTitle.swtch_prfl') }}</b-dropdown-item>
            <b-dropdown-item v-if="$engine.firstOn().rights.rightIs('settings_consult',true)" @click="goToLink('/settings/application/')" class="subItemTextWebHeader dropdown-item-web-header">{{ $t('Webheader.settings') }}</b-dropdown-item>
            <b-dropdown-item @click="logout" class="subItemTextWebHeader dropdown-item-web-header">{{ this.$t('leftPanelTitle.lgout') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav fill class="mx-0 mx-lg-1">
          <b-nav-item-dropdown 
            right 
            toggle-class="border-0 p-0 bg-none m-md-2 text-dark bg-none-first-child"
            :aria-label="$t('common.language_selector')">
            <template slot="button-content">
              <img class="flag-nav" :src="language === 'FR' ? logoFlagFR : logoFlagEN" :alt="language === 'FR' ? 'Drapeau français' : 'Drapeau anglais'"/>
              <span class="d-inline">{{ labelLanguage }}</span>
            </template>
            <b-dropdown-item v-for="option in options" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
              <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt="Drapeau français"/>
              <img class="flag-nav" v-else :src="logoFlagEN" alt="Drapeau anglais"/>
              <span>{{ option.text }}</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
    </b-navbar>
    
    <!-- Header inférieur avec navigation -->
    <b-navbar type="faded" class="header-bottom d-flex justify-content-center p-1" role="navigation" aria-label="Navigation principale">
      <nav role="navigation" aria-label="Menu principal" class="w-100" ref="navigationContainer">
        <b-navbar-nav class="m-auto justify-content-center responsive-nav-menu" fill :key="resetMenu" ref="navMenu">
        <template v-for="(item, id) in menu">
          <b-nav-item-dropdown v-if="!item.hidden && !isDisabledItem(item) && item.list && hasOneRight(item.list)" 
            :key="'dropdown-' + id"
            :ref="'dropdown' + id" 
            :text="$t(item.title)"
            toggle-class="text-menu" 
            class="font-weight-bold dropDownInnerWebHeader px-1 py-0 mt-1 small"
            :class="{selectedMenuItemWebHeader: item.list.some((e) => selectedMenu === e.link)}"
            @mouseover.native="autoDropdown(true, 'dropdown' + id)" 
            @mouseleave.native="autoDropdown(false, 'dropdown' + id)"
            :aria-label="$t(item.title)"
            aria-haspopup="true"
            :aria-expanded="false">
            <div slot="button-content" style="display: inline-block">
              <span>{{ $t(item.title) }}</span>
              <div class="border-bottom pt-2 border-success position-absolute" style="width: 100%; left: 0; right: 0;" v-if="item.list.some((e) => selectedMenu === e.link)"></div>
            </div>
            <b-dropdown-item v-for="subitem in item.list"
              v-if="!isDisabledItem(subitem) && canShowSpecific(subitem)"
              :disabled="!subitem.enabled"
              class="dropdown-item-web-header mb-1"
              :class="{selectedMenuItemWebHeader: selectedMenu === subitem.link, subItemMenuWebHeader: subitem.id === 0, subItemTextWebHeader: subitem.id !== 0}"
              :key="subitem.id" @click="getClicked(subitem)"
              :aria-label="$t(subitem.title)">
              <span class="pb-1">{{ $t(subitem.title) }}</span>
              <span v-if="!subitem.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-else-if="!item.hidden && !isDisabledItem(item) && !item.list"
            :key="'item-' + id"
            :disabled="!item.enabled"
            class="text-menu subItemTextOnlyWebHeader px-1 py-0 mt-1 font-weight-bold small"
            :class="{selectedMenuItemWebHeader: selectedMenu === item.link}"
            :link-classes="{borderSuccessMenu: selectedMenu === item.link}"
            @click="getClicked(item)"
            :aria-label="$t(item.title)">
            {{ $t(item.title) }}
            <span v-if="!item.link" class="disabled ml-1">{{ $t('common.dsbld') }}</span>
            <!--DRO 03/07/2023 : Commenté l'attribut 'style'. Enlever les classes et remettre le style si nécessaire-->
            <div class="border-bottom pt-2 border-success position-absolute" style="width: 100%; left: 0; right: 0;" v-if="item.link === selectedMenu"></div>
          </b-nav-item>
        </template>
        </b-navbar-nav>
      </nav>
    </b-navbar>
  </div>
</template>

<script>
import ProfileImage from './../../assets/static/images/image-profile2.png'
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import {loadPage, reloadPage2} from './../../helpers/routing'
import CompanyTheme from './../../helpers/companyTheme.json'
import Services from '@/helpers/services'
import design from '@/design/design.json'
import conf from "@/config/config.dev";


/* Barre de navigation sur grands écran (ordinateurs), et liens contenus dans celle-ci */
export default {
  name: 'WebHeader',
  props: {
  },
  data () {
    return {
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      accountType: 0,
      companyId: 0,
      companyName: '',
      companyTheme: CompanyTheme,
      design: design.menu,
      language: '',
      languageLabel: 'Français',
      logoProfile: ProfileImage,
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      menu: {},
      menuLinkList: null,
      options: [],
      resetMenu: false,
      selectedMenu: '',
      userName: '',
      dropdownTimeouts: {} // Pour stocker les timeouts de fermeture
    }
  },
  created () {
    this.language = this.$i18n.locale.toUpperCase()
    this.options = [
      { value: 'FR', text: this.$t('lang.french')},
      { value: 'EN', text: this.$t('lang.english')}
    ]
    this.menuLinkList = require('./data/menu.json')
    if (this.$engine.firstOn().user.get().name != null) {
      this.companyName = this.$engine.firstOn().user.get().name
    }
    this.getUsername()
    this.accountType = this.$engine.firstOn().user.get().type
    this.companyId = this.$engine.firstOn().user.get().id
    this.setMenuItems()
    this.$bus.$on('refresh-cache-menu', () => {
      this.companyName = this.$engine.firstOn().user.get().name
      this.accountType = this.$engine.firstOn().user.get().type
      this.setMenuItems()
    })
    let that = this
    this.$bus.$off('reset-selected-menu')
    this.$bus.$on('reset-selected-menu', function () {
      that.selectedMenu = ''
      let elem = document.getElementsByClassName('selectedMenuItemWebHeader').item(0)
      if (elem) {
        elem.classList.remove('selectedMenuItemWebHeader')
      }
      that.resetMenu = !that.resetMenu
    })
    this.$bus.$on('switch-selected-menu', function(newUrl) {
      that.selectedMenu = newUrl
    })
    if (this.$engine.firstOn().auth.isAuth() && this.$f7.getCurrentView().url === '/login/') {
      this.selectedMenu = '/home/'
    } else {
      this.verifyCurrentView()
    }
    this.canUserSeePage()
  },
  mounted () {
    // Navigation responsive gérée par CSS
  },
  beforeDestroy() {
    // Nettoyer tous les timeouts avant de détruire le composant
    Object.keys(this.dropdownTimeouts).forEach(key => {
      clearTimeout(this.dropdownTimeouts[key])
    })
    this.dropdownTimeouts = {}
  },
  computed: {
    hasRightHRTP () {
      let currentRights = this.$engine.firstOn().rights.getAll()
      let rightHRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_hrtp') && right[1] === true) {
          rightHRTPFound = true
        }
      })
      return rightHRTPFound
    },
    hasRightSRTP () {
      let currentRights = this.$engine.firstOn().rights.getAll()
      let rightSRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_srtp') && right[1] === true) {
          rightSRTPFound = true
        }
      })
      return rightSRTPFound
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    imgProfil () {
      return this.design.headbandProfilePic
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.options.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.$t('lang.french')
      if (langOpt.length) {
        label = langOpt[0].text
      }
      return label
    }
  },
  methods: {
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    autoDropdown (value, id) {
      // Si on veut ouvrir le dropdown
      if (value) {
        // Annuler tout timeout de fermeture en cours pour ce dropdown
        if (this.dropdownTimeouts[id]) {
          clearTimeout(this.dropdownTimeouts[id])
          delete this.dropdownTimeouts[id]
        }
        // Ouvrir le dropdown immédiatement
        Object.keys(this.$refs).forEach((item) => {
          if (item === id) {
            if (this.$refs[item][0]) {
              this.$refs[item][0].visible = true
            } else {
              this.$refs[item].visible = true
            }
          }
        })
      } else {
        // Si on veut fermer le dropdown, le faire avec un délai
        this.dropdownTimeouts[id] = setTimeout(() => {
          Object.keys(this.$refs).forEach((item) => {
            if (item === id) {
              if (this.$refs[item][0]) {
                this.$refs[item][0].visible = false
              } else {
                this.$refs[item].visible = false
              }
            }
          })
          delete this.dropdownTimeouts[id]
        }, 150) // Délai de 150ms avant fermeture
      }
    },
    canShowSpecific (subItem) {
      if ((subItem.link === '/rights/profiles/') && this.$engine.firstOn().user.get().type === '2') {
        return false
      }
      return true
    },
    canUserSeePage () {
      let currentPage = {}
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.selectedMenu) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.selectedMenu) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (Object.keys(currentPage).length === 0) {
        return
      }
    },
    getBackground () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].background) {
        return 'background: ' + this.companyTheme[this.companyId].background
      }
    },
    getClicked (subitem) {
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.firstOn().user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.PAYMENTS))
          this.$engine.firstOn().user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.firstOn().user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.firstOn().user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.SUPPLIERS))
          this.$engine.firstOn().user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.PAYMENTS))
              this.$engine.firstOn().user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.firstOn().user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.firstOn().user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.firstOn().user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.SUPPLIERS))
              this.$engine.firstOn().user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.firstOn().user.changeService(this.$engine.firstOn().services.getServiceById(Services.VERIFICATIONS))
              this.$engine.firstOn().user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      this.selectedMenu = subitem.link
      reloadPage2(that, subitem.link)
    },
    getLargeLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoLarge) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoLarge
      } else {
        return require('./../../assets/static/images/logo/dealprudence_white_green.png')
      }
    },
    getMiddleLogo () {
      if (this.companyTheme[this.companyId] && this.companyTheme[this.companyId].logoMiddle) {
        return './../../assets/static/images/logo/' + this.companyTheme[this.companyId].logoMiddle
      } else {
        return require('./../../assets/static/images/logo/mrlogo.png')
      }
    },
    getUsername () {
      let info = this.$engine.firstOn().accounts.get()
      let userAccounts
      let userAccountId
      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUsername(userAccounts)
    },
    goToLink (linkToGo) {
      this.selectedMenu = linkToGo
      this.$f7.mainView.router.load({url: linkToGo, reload: true})
    },
    goToLoginPage () {
      var that = this
      loadPage(that, {url: '/login/'})
    },
    hasMultipleAccounts () {
      let accounts = this.$engine.firstOn().accounts.get()
      let diffAccounts = []
      accounts.forEach(account => {
        if (!diffAccounts.includes(account.id)) {
          diffAccounts.push(account.id)
        }
      })
      return diffAccounts.length > 1
    },
    hasOneRight (itemList) {
      let that = this
      return itemList.filter(item => {
        return !that.isDisabledItem(item)
      }).length
    },
    isDisabledItem (item) {
      /* if (item && !item.enabled) {
        return true
      } */
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        if (item.right_disable.right === 'rights_profile_consult') {
          return this.$engine.firstOn().user.get().id === this.$engine.firstOn().user.get()
          ? this.$engine.firstOn().rights.rightIs('rights_admin_consulter', item.right_disable.state)
          : this.$engine.firstOn().rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        // Return true if the right has the same state as the disabling state
        return this.$engine.firstOn().rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    },
    isSubMenuActive (item) {
      let that = this
      return item.list.filter(elem => elem.link === that.selectedMenu).length
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
        document.documentElement.lang = 'en'
      } else {
        this.$i18n.locale = 'fr'
        document.documentElement.lang = 'fr'
      }
      this.options = [
        { value: 'FR', text: this.$t('lang.french')},
        { value: 'EN', text: this.$t('lang.english')}
      ]
    },
    loadAccueil () {
      var that = this
      this.selectedMenu = '/home/'
      loadPage(that, {url: this.flagTOOLBOX ? '/homecarrousel/' : '/home/'})
    },
    logout () {
      this.$bus.emit('logout')
    },
    setMenuItems () {
      this.menu = this.menuLinkList['linkContent']
      // compter le nombre de pages dispo
      let nbPage = 0
      let link = ''
      let that = this
      this.menu.forEach((item, index) => {
        if (item.list && item.list.length) {
          if (that.hasOneRight(item.list) && !that.isDisabledItem(item)) {
            item.list.forEach((subitem, subindex) => {
              if (subitem.enabled && that.canShowSpecific(subitem) && !that.isDisabledItem(subitem)) {
                nbPage++
                link = subitem.link
              }
            });
          }
        } else if (item.enabled && !that.isDisabledItem(item)) {
          nbPage++
          link = item.link
        }
      })
      if (nbPage === 1 ) {
        reloadPage2(that, link)
      }
    },
    updateUsername (userAccount) {
      this.userAccountInfo = userAccount
      this.userName = this.userAccountInfo[0].name
    },
    verifyCurrentView () {
      let pageExistsInMenu = false
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.$f7.getCurrentView().url) {
          pageExistsInMenu = true
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.$f7.getCurrentView().url) {
              pageExistsInMenu = true
              return
            }
          })
        }
      })
      if (pageExistsInMenu === true || this.$f7.getCurrentView().url === '/home/' || this.$f7.getCurrentView().url === '/profile/' || this.$f7.getCurrentView().url === '/settings/application/') {
        this.selectedMenu = this.$f7.getCurrentView().url
      } else {
        //Pour le cas des détails Dashboard par exemple DRO 02/08/2024
        this.selectedMenu = this.$f7.mainView.history[this.$f7.mainView.history.length - 2]
      }
    }
  }

}
</script>

<style scoped>
/* Navigation header simple et efficace */
:root {
  --nav-font-size: 0.875rem;
  --nav-padding: 0.5rem;
  --nav-gap: 0.25rem;
}

/* Header à deux niveaux */
.header-top {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.5rem 1rem !important;
  position: relative;
  z-index: 1030;
}

.header-bottom {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 0.5rem 1rem !important;
  min-height: 50px;
  width: 100%;
  position: relative;
  z-index: 1020;
}

/* Navigation principale */
.responsive-nav-menu {
  display: flex !important;
  flex-wrap: nowrap !important;
  gap: var(--nav-gap);
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
  margin: 0 !important;
}

/* Éléments de navigation */
.header-bottom .nav-item {
  margin: 0 var(--nav-gap) !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Styles uniformes pour tous les liens de menu */
.header-bottom .dropDownInnerWebHeader,
.header-bottom .subItemTextOnlyWebHeader,
.header-bottom .dropdown-toggle {
  font-size: var(--nav-font-size) !important;
  padding: 0.25rem var(--nav-padding) !important;
  color: #333 !important;
  text-decoration: none !important;
  white-space: nowrap !important;
  border: none !important;
  background: transparent !important;
  display: inline-block !important;
  text-align: center !important;
  transition: color 0.2s ease, background-color 0.2s ease !important;
}

/* États hover et focus uniformes */
.header-bottom .dropDownInnerWebHeader:hover,
.header-bottom .subItemTextOnlyWebHeader:hover,
.header-bottom .dropdown-toggle:hover,
.header-bottom .nav-link:hover {
  color: #000000 !important;
  background-color: rgba(17, 176, 175, 0.1) !important;
}

/* Responsive simple */
@media (max-width: 1200px) {
  :root {
    --nav-font-size: 12px;
    --nav-padding: 0.4rem;
    --nav-gap: 0.2rem;
  }
  
  /* Forcer toutes les tailles de police à 12px */
  .subItemTextOnlyWebHeader a,
  .dropDownInnerWebHeader,
  .dropDownInnerWebHeader span,
  .dropdown-toggle,
  .nav-link {
    font-size: 12px !important;
  }
}

@media (max-width: 1100px) {
  :root {
    --nav-font-size: 8px;
    --nav-padding: 0.35rem;
    --nav-gap: 0.18rem;
  }
  
  /* Forcer toutes les tailles de police à 8px */
  .subItemTextOnlyWebHeader,
  .subItemTextOnlyWebHeader a,
  .dropDownInnerWebHeader,
  .dropDownInnerWebHeader span,
  .dropdown-toggle,
  .nav-link,
  .dropdown-item-web-header,
  .dropdown-item-web-header span,
  .profile-menu {
    font-size: 8px !important;
  }
}

@media (max-width: 900px) {
  :root {
    --nav-font-size: 8px;
    --nav-padding: 0.3rem;
    --nav-gap: 0.15rem;
  }
  
  /* Forcer toutes les tailles de police à 8px */
  .subItemTextOnlyWebHeader,
  .subItemTextOnlyWebHeader a,
  .dropDownInnerWebHeader,
  .dropDownInnerWebHeader span,
  .dropdown-toggle,
  .nav-link,
  .dropdown-item-web-header,
  .dropdown-item-web-header span,
  .profile-menu {
    font-size: 8px !important;
  }
}

@media (max-width: 600px) {
  :root {
    --nav-font-size: 6px;
    --nav-padding: 0.25rem;
    --nav-gap: 0.1rem;
  }
  
  /* Forcer toutes les tailles de police à 6px */
  .subItemTextOnlyWebHeader,
  .subItemTextOnlyWebHeader a,
  .dropDownInnerWebHeader,
  .dropDownInnerWebHeader span,
  .dropdown-toggle,
  .nav-link,
  .dropdown-item-web-header,
  .dropdown-item-web-header span,
  .profile-menu {
    font-size: 6px !important;
  }
}

/* Flèche dropdown */
.header-bottom .dropdown-toggle::after {
  margin-left: 0.25rem !important;
}

/* Styles pour la sélection et l'état actif */
.header-bottom .selectedMenuItemWebHeader {
  font-weight: bold !important;
  color: #11B0AF !important;
}

.header-bottom .border-bottom.border-success {
  border-bottom: 2px solid #11B0AF !important;
  width: 100% !important;
  margin-top: 0.25rem;
  left: 0 !important;
  right: 0 !important;
}

/* Éléments fixes du header */
.heritage-web-header {
  max-height: 40px !important;
  margin: 0 !important;
}

.navbar-brand {
  padding: 0 !important;
  margin-right: 1rem;
}

.navbarProfileImage {
  width: 30px !important;
  height: 30px !important;
}

.profile-menu {
  font-size: 0.8rem !important;
  line-height: 1.2 !important;
}

.flag-nav {
  width: 20px !important;
  height: auto !important;
  margin-right: 0.25rem;
}

/* Dropdowns */
.header-bottom .dropdown-menu {
  font-size: 0.8rem !important;
  padding: 0.5rem 0 !important;
  border: 1px solid rgba(17, 176, 175, 0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  background-color: #fff !important;
  margin-top: 0.5rem !important;
  z-index: 1050 !important;
}

.header-bottom .dropdown-item-web-header {
  font-size: 0.8rem !important;
  padding: 0.5rem 1.25rem !important;
  color: #333 !important;
  transition: all 0.2s ease !important;
  border: none !important;
  background: transparent !important;
}

.header-bottom .dropdown-item-web-header:hover {
  background-color: rgba(17, 176, 175, 0.08) !important;
  color: #000000 !important;
  padding-left: 1.5rem !important;
}

.header-bottom .dropdown-item-web-header:focus {
  outline: 2px solid rgba(17, 176, 175, 0.3) !important;
  outline-offset: -2px !important;
  background-color: rgba(17, 176, 175, 0.05) !important;
}

.header-bottom .dropdown-item-web-header.selectedMenuItemWebHeader {
  background-color: rgba(17, 176, 175, 0.1) !important;
  color: #11B0AF !important;
  font-weight: 600 !important;
}

/* Séparateur visuel pour les groupes d'items */
.header-bottom .dropdown-divider {
  margin: 0.5rem 0 !important;
  border-color: rgba(17, 176, 175, 0.1) !important;
}

.logOut .dropdown-toggle {
  padding: 0.25rem 0.5rem !important;
  transition: all 0.2s ease !important;
  border-radius: 6px !important;
}

.logOut:hover .dropdown-toggle {
  background-color: rgba(17, 176, 175, 0.05) !important;
}

/* Style pour le dropdown du profil utilisateur */
.logOut .dropdown-menu {
  min-width: 200px !important;
  border: 1px solid rgba(17, 176, 175, 0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  padding: 0.75rem 0 !important;
  z-index: 1050 !important;
}

.logOut .dropdown-item {
  padding: 0.5rem 1.25rem !important;
  transition: all 0.2s ease !important;
  color: #333 !important;
}

.logOut .dropdown-item:hover {
  background-color: rgba(17, 176, 175, 0.08) !important;
  color: #000000 !important;
  padding-left: 1.5rem !important;
}

/* Lien d'évitement accessible */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: #000;
  color: #fff;
  padding: 8px;
  text-decoration: none;
  z-index: 100;
  border-radius: 4px;
  font-weight: bold;
}

.skip-link:focus {
  top: 6px;
  color: #fff;
  text-decoration: none;
}

.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

/* Style pour le dropdown de langue */
.navbar-nav .dropdown-menu {
  min-width: 150px !important;
  border: 1px solid rgba(17, 176, 175, 0.2) !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  z-index: 1050 !important;
}

.navbar-nav .dropdown-item {
  padding: 0.5rem 1rem !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
}

.navbar-nav .dropdown-item:hover {
  background-color: rgba(17, 176, 175, 0.08) !important;
  color: #000000 !important;
}
</style>
